import { useEffect, useState } from 'react';
import { authzClient } from '../connect';
export const audienceKey = (a)=>`${a.kind}:${a.scopeNodeId || a.principalGroupId}`;
/** Member-projected directory only; never use the admin directory as a fallback. */ export function useAudienceDirectory(query = '', enabled = true) {
    const [refresh, setRefresh] = useState(0);
    const [state, setState] = useState({
        choices: [],
        loading: true,
        error: false
    });
    useEffect(()=>{
        if (!enabled) return;
        const controller = new AbortController();
        setState({
            choices: [],
            loading: true,
            error: false
        });
        const timer = setTimeout(()=>{
            void Promise.all([
                authzClient.listScopeNodes({
                    query,
                    limit: 200
                }, {
                    signal: controller.signal
                }),
                authzClient.listAudienceGroups({}, {
                    signal: controller.signal
                })
            ]).then(([scopes, groups])=>{
                if (controller.signal.aborted) return;
                const choices = [
                    ...scopes.scopeNodes.filter((n)=>n.displayName.trim()).map((n)=>({
                            key: `scope_node:${n.id}`,
                            name: n.displayName,
                            kind: 'scope_node',
                            scopeNodeId: n.id,
                            principalGroupId: ''
                        })),
                    ...groups.groups.filter((g)=>g.displayName.trim() && g.displayName.toLocaleLowerCase().includes(query.toLocaleLowerCase())).map((g)=>({
                            key: `principal_group:${g.id}`,
                            name: g.displayName,
                            kind: 'principal_group',
                            scopeNodeId: '',
                            principalGroupId: g.id
                        }))
                ];
                setState({
                    choices,
                    loading: false,
                    error: false
                });
            }).catch(()=>{
                if (!controller.signal.aborted) setState({
                    choices: [],
                    loading: false,
                    error: true
                });
            });
        }, 250);
        return ()=>{
            clearTimeout(timer);
            controller.abort();
        };
    }, [
        query,
        enabled,
        refresh
    ]);
    return {
        ...state,
        retry: ()=>setRefresh((n)=>n + 1)
    };
}
